<template>
  <dashboard-layout :menu="tabs" :fluid="false">
    <template v-if="deadlinePassed" #alert>
      <info-box :no-margin="true">
        The deadline for this study has passed. You can still submit your
        studies but they will no longer be available for critique.
      </info-box>
    </template>
    <div class="study container container--fluid container--vertical">
      <failed-to-load v-if="failed" />
      <template v-else>
        <h1>{{ title }}</h1>
        <transition name="route-switch" mode="out-in">
          <router-view />
        </transition>
      </template>
    </div>
  </dashboard-layout>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import FailedToLoad from '@/components/global/FailedToLoad';
import InfoBox from '@/components/app/InfoBox';

export default {
  name: 'study-view',
  data: function() {
    return {
      failed: false,
      tabs: [
        {
          title: 'All studies',
          exact: false,
          route: 'art-club',
          icon: 'chevron-left',
        },
        {
          title: 'resources',
          exact: false,
          route: 'art-club-study',
          icon: 'folder',
        },
        {
          title: 'gallery',
          exact: false,
          route: 'art-club-study-gallery',
          icon: 'images',
        },
        {
          title: 'my submissions',
          exact: false,
          route: 'art-club-study-submit',
          icon: 'user-graduate',
        },
      ],
    };
  },
  async mounted() {
    const response = await this.getStudy(this.$route.params.id);
    if (response && response.status >= 300 && !this.title) {
      this.failed = true;
    }
  },
  components: { FailedToLoad, InfoBox },
  methods: {
    ...mapActions('study', ['getStudy']),
  },
  computed: {
    ...mapState('study', {
      title: state => state.title,
      deadline: state => state.deadline,
    }),
    deadlinePassed() {
      const now = new Date();
      const dl = new Date(this.deadline);
      return now - dl >= 0;
    },
  },
};
</script>
